import { Box, Typography } from '@mui/material';
import IntegrationSelect from '../../../IntegrationSelect';
import { type INTEGRATIONS, type INTEGRATIONS_V2 } from '../../../components/IntegrationButton';
import { Logo } from '../Logo';
import { HeaderWrapper, IntegrationSelectWrapper, LabelWrapper, LogoWrapper } from './styles';
import { useTranslation } from 'react-i18next';

type HeaderProps = {
  integrationName: INTEGRATIONS | INTEGRATIONS_V2 | 'none';
  setIntegrationName: (integration: INTEGRATIONS | INTEGRATIONS_V2 | 'none') => void;
};

export const Header = ({ integrationName, setIntegrationName }: HeaderProps) => {
  const { t } = useTranslation(['settings']);

  return (
    <Box>
      <Box>
        <LabelWrapper gutterBottom variant="subtitle1">
          {t('integrations.select system')}:
        </LabelWrapper>
      </Box>

      <HeaderWrapper mb={4} columnGap={2}>
        <IntegrationSelectWrapper>
          <IntegrationSelect integrationName={integrationName} setIntegrationName={setIntegrationName} />
        </IntegrationSelectWrapper>
        {integrationName !== 'none' && (
          <LogoWrapper>
            <Logo logoName={integrationName} />
          </LogoWrapper>
        )}
      </HeaderWrapper>
    </Box>
  );
};
